import Button from 'theme/components/button';

export default { Button };
